<div
  [attr.data-testid]="props.testId ?? null"
  [innerHTML]="props.html || ''"
>
</div>
